export type JobOption = { outsideUsualJob?: boolean };

export type ShowAllLabels = { showAll: string, others: string };

export const TRUCK_LABELS: ShowAllLabels = { showAll: "Show all trucks", others: "Other trucks" };

export const PLANT_MODEL_LABELS: ShowAllLabels = { showAll: "Show all models", others: "Other plant models" };

export const LOADING_MACHINE_LABELS: ShowAllLabels = { showAll: "Show all loading machines", others: "Other loading machines" };
